import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="countdown"
export default class extends Controller {
  static values = { expiresAt: String }
  
  connect() {
    this.updateCountdown()
    this.timer = setInterval(() => {
      this.updateCountdown()
    }, 1000) // Update every second
  }
  
  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
  
  updateCountdown() {
    if (!this.expiresAtValue) {
      this.element.textContent = "N/A"
      return
    }

    const now = new Date()
    const expiresAt = new Date(this.expiresAtValue)
    const secondsLeft = Math.floor((expiresAt - now) / 1000)

    if (secondsLeft <= 0) {
      this.element.textContent = "Expired"
      // Stop the timer to prevent continuous updates
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      return
    }

    const hours = Math.floor(secondsLeft / 3600)
    const minutes = Math.floor((secondsLeft % 3600) / 60)
    const seconds = secondsLeft % 60

    // Always show all three units
    const display = `${hours}h ${minutes}m ${seconds}s`

    this.element.textContent = display
  }
}